import { apiClient } from "../../../client";
import { Robot } from "@domain/robot";
import { StandardAxiosConfig, getBaseDataURL } from "../../../common";
import { DataAPI_Base, GetAPI_Base } from "../base";
import { Filter } from "../../../common";

interface RobotDetailOpts {
	raw?: boolean;
	timeline?: boolean;
}

const hydrateLastUpdated = (robot: Robot): Robot => {
	if (robot.lastUpdated && typeof robot.lastUpdated === "string") {
		robot.lastUpdated = new Date(robot.lastUpdated);
	}
	return robot;
};

class GetAPI_RobotsBase extends GetAPI_Base<Robot> {
	public async byFilter(filter?: Filter<Robot>): Promise<Robot[]> {
		const records = await super.byFilter(filter);
		records.forEach(hydrateLastUpdated);
		return records;
	}

	public async byId(id: string, isCompressed?: boolean): Promise<Robot> {
		const record = await super.byId(id, isCompressed);
		return hydrateLastUpdated(record);
	}
}

class GetAPI_Robots {
	private baseUrl: string;

	constructor() {
		this.baseUrl = `${getBaseDataURL("robots")}/get`;
	}

	public async byIdWithDetail(id: string, start: Date, end: Date, opts: RobotDetailOpts): Promise<Robot> {
		const params = new URLSearchParams({
			start: start.toISOString(),
			end: end.toISOString(),
		});
		if (opts.raw) params.set("raw", "true");
		if (opts.timeline) params.set("timeline", "true");
		const url = `${this.baseUrl}/${id}?${params}`;
		const response = await apiClient.get(url, StandardAxiosConfig());
		const robot = Object.assign(new Robot(), response.data as Robot);
		hydrateLastUpdated(robot);
		// Sort once at fetch so downstream consumers can rely on chronological order.
		if (robot.raw) robot.raw.sort((a, b) => a.timestamp - b.timestamp);
		if (robot.timeline) robot.timeline.sort((a, b) => a.start - b.start);
		return robot;
	}
}

export class RobotsAPI extends DataAPI_Base<Robot> {
	robots: GetAPI_Robots;
	constructor() {
		super("robots", Robot);
		this.get = new GetAPI_RobotsBase("robots", Robot);
		this.robots = new GetAPI_Robots();
	}
}
